// Pasek wartości („Jakość · Dbałość o szczegóły · …”) jako przewijany pasek CSS.
// Wcześniej Splide + AutoScroll przeliczał pozycję w JS w każdej klatce (koszt INP/TBT);
// teraz lista jest zdublowana i przesuwana animacją transform (kompozytor, bez głównego wątku).
// Od 1500px pasek jest statyczny i wyśrodkowany — jak wcześniej (breakpoint destroy w Splide).
(function () {
  var SPEED = 48; // px/s — odpowiednik autoScroll.speed 0.8 przy 60 fps
  var DESKTOP = window.matchMedia('(min-width: 1500px)');

  function injectStyles() {
    if (document.getElementById('nk-values-marquee-css')) return;
    var style = document.createElement('style');
    style.id = 'nk-values-marquee-css';
    style.textContent = [
      '.valuesBar__wrapper.splide { visibility: visible; }',
      '.valuesBar__wrapper .splide__track { overflow: hidden; }',
      '.valuesBar__wrapper.nk-marquee .splide__list { display: flex !important; flex-wrap: nowrap; gap: 0 !important; width: max-content; animation: nk-values-marquee var(--nk-marquee-duration, 30s) linear infinite; will-change: transform; }',
      '.valuesBar__wrapper.nk-marquee .splide__slide { flex-shrink: 0; margin-right: 36px; }',
      '@media (max-width: 400px) { .valuesBar__wrapper.nk-marquee .splide__slide { margin-right: 24px; } }',
      '@keyframes nk-values-marquee { from { transform: translate3d(0, 0, 0); } to { transform: translate3d(-50%, 0, 0); } }',
      '@media (prefers-reduced-motion: reduce) { .valuesBar__wrapper.nk-marquee .splide__list { animation: none; } }'
    ].join('\n');
    document.head.appendChild(style);
  }

  function enable(wrapper) {
    var list = wrapper.querySelector('.splide__list');
    if (!list || wrapper.classList.contains('nk-marquee')) return;
    var items = Array.prototype.filter.call(list.children, function (el) {
      return el.tagName === 'LI' && !el.hasAttribute('data-nk-clone');
    });
    if (!items.length) return;
    items.forEach(function (item) {
      var clone = item.cloneNode(true);
      clone.setAttribute('data-nk-clone', '');
      clone.setAttribute('aria-hidden', 'true');
      list.appendChild(clone);
    });
    wrapper.classList.add('nk-marquee');
    var half = list.scrollWidth / 2;
    wrapper.style.setProperty('--nk-marquee-duration', Math.max(half / SPEED, 5).toFixed(1) + 's');
  }

  function disable(wrapper) {
    if (!wrapper.classList.contains('nk-marquee')) return;
    wrapper.classList.remove('nk-marquee');
    wrapper.querySelectorAll('[data-nk-clone]').forEach(function (el) { el.remove(); });
  }

  function update() {
    document.querySelectorAll('.valuesBar__wrapper').forEach(function (wrapper) {
      if (DESKTOP.matches) disable(wrapper);
      else enable(wrapper);
    });
  }

  function init() {
    injectStyles();
    update();
    if (DESKTOP.addEventListener) DESKTOP.addEventListener('change', update);
    else if (DESKTOP.addListener) DESKTOP.addListener(update);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
